import { c as _c } from "react/compiler-runtime";
import type { GetPublicPartnerCreatorRow } from '@morfi/backend-sdk-v2/client';
import { useTranslations } from 'next-intl';
import { partnerSocialIcon, partnerSocialLabel } from '@/components/market/identity/partner-social';
import { Icon } from '@/components/ui/icon';
import { Globe02Icon } from '@/components/ui/icon/glyphs';
import { IdentityPill } from '@/components/ui/identity-pill';
import { capitalizeLeading, resolveProposalCategory } from '@/config/proposal-display';
export function PartnerProfileDetails(t0) {
  const $ = _c(13);
  const {
    profile
  } = t0;
  const t = useTranslations("profile.partner");
  let t1;
  if ($[0] !== profile.bio) {
    t1 = profile.bio ? <p className="whitespace-pre-wrap break-words text-body">{profile.bio}</p> : null;
    $[0] = profile.bio;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== profile.introduction) {
    t2 = profile.introduction ? <p className="whitespace-pre-wrap break-words text-body text-foreground-secondary">{profile.introduction}</p> : null;
    $[2] = profile.introduction;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== profile.categories || $[5] !== profile.socialLinks || $[6] !== profile.website || $[7] !== t) {
    t3 = profile.website || profile.socialLinks.length > 0 || profile.categories.length > 0 ? <div className="flex flex-wrap items-center gap-3 text-body">{profile.website ? <a className="inline-flex items-center gap-1.5 break-all text-foreground-secondary hover:text-foreground-primary" href={profile.website} target="_blank" rel="noopener noreferrer"><Icon icon={Globe02Icon} size={16} />{t("website")}</a> : null}{profile.socialLinks.map(social => <a key={social.platform} className="inline-flex items-center gap-1.5 break-all text-foreground-secondary hover:text-foreground-primary" href={social.url} target="_blank" rel="noopener noreferrer"><Icon icon={partnerSocialIcon(social.platform)} size={16} />{partnerSocialLabel(social.platform)}<span className="sr-only"> {t("verified")}</span></a>)}{profile.categories.map(_temp)}</div> : null;
    $[4] = profile.categories;
    $[5] = profile.socialLinks;
    $[6] = profile.website;
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t4 = <div className="space-y-4 px-4 pt-4 sm:px-6">{t1}{t2}{t3}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
function _temp(category) {
  const option = resolveProposalCategory(category);
  return <IdentityPill key={category} tone="neutral" emoji={option?.emoji}>{option?.name ?? capitalizeLeading(category)}</IdentityPill>;
}